import type { FetchParams } from './reducer';

export const INIT = 'app/ExternalDonationRequests/INIT';

export const APPROVE = 'app/ExternalDonationRequests/APPROVE';
export const DENY = 'app/ExternalDonationRequests/DENY';
export const RESPOND_SUCCESS = 'app/ExternalDonationRequests/RESPOND_SUCCESS';
export const RESPOND_FAILED = 'app/ExternalDonationRequests/RESPOND_FAILED';

export const SET_FETCH_PARAMS = 'app/ExternalDonationRequests/SET_FETCH_PARAMS';
export const SET_TOTAL = 'entities/ExternalDonationRequests/SET_TOTAL';
export const SET_DISPLAYED_DONATION_IDS =
  'entities/ExternalDonationRequests/SET_DISPLAYED_DONATION_IDS';
export const FETCH_SUCCESS = 'app/ExternalDonationRequests/FETCH_SUCCESS';
export const FETCH_FAILED = 'app/ExternalDonationRequests/FETCH_FAILED';

export const FORM_IDENTIFIER = 'app/ExternalDonationRequests';

export enum MATCHING_REQUEST_STATUS_DISPLAY_KEYS {
  approved = 'approved',
  denied = 'denied',
  pending = 'pending',
}

export enum MATCHING_REQUEST_STATUSES {
  approved = 'Approved',
  denied = 'Rejected',
  pending = 'Pending',
}

export enum MATCHING_REQUEST_STATUS_DATE_FIELD {
  Approved = 'matchedAt',
  Rejected = 'metadata.matchRequestRejectedAt',
  Pending = 'createdAt',
}

export interface InitAction {
  type: typeof INIT;
}
export const initAction = (): InitAction => ({
  type: INIT,
});

export interface ApproveAction {
  type: typeof APPROVE;
  donationIds: string[];
}
export const approveAction = (donationIds: string[]): ApproveAction => ({
  type: APPROVE,
  donationIds,
});

export interface DenyAction {
  type: typeof DENY;
  donationIds: string[];
  rejectionReason: string;
}
export const denyAction = (donationIds: string[], rejectionReason: string): DenyAction => ({
  type: DENY,
  donationIds,
  rejectionReason,
});

export interface RespondSuccess {
  type: typeof RESPOND_SUCCESS;
  donationIds: string[];
}
export const respondSuccess = (donationIds: string[]): RespondSuccess => ({
  type: RESPOND_SUCCESS,
  donationIds,
});
export interface RespondFailed {
  type: typeof RESPOND_FAILED;
  donationIds: string[];
}
export const respondFailed = (donationIds: string[]): RespondFailed => ({
  type: RESPOND_FAILED,
  donationIds,
});

export interface FetchParamsAction {
  type: typeof SET_FETCH_PARAMS;
  params: Partial<FetchParams>;
}
export const setFetchParamsAction = (params: Partial<FetchParams>): FetchParamsAction => ({
  type: SET_FETCH_PARAMS,
  params,
});

export interface SetTotalAction {
  type: typeof SET_TOTAL;
  total: number;
}
export const setTotalAction = (total: number): SetTotalAction => ({
  type: SET_TOTAL,
  total,
});

export interface SetDisplayedDonationIdsAction {
  type: typeof SET_DISPLAYED_DONATION_IDS;
  donationIds: string[];
}
export const setDisplayedDonationIdsAction = (
  donationIds: string[]
): SetDisplayedDonationIdsAction => ({
  type: SET_DISPLAYED_DONATION_IDS,
  donationIds,
});

export interface FetchSuccessAction {
  type: typeof FETCH_SUCCESS;
}
export const fetchSuccessAction = (): FetchSuccessAction => ({
  type: FETCH_SUCCESS,
});

export interface FetchFailedAction {
  type: typeof FETCH_FAILED;
  error: Error;
}
export const fetchFailedAction = (error: Error): FetchFailedAction => ({
  type: FETCH_FAILED,
  error,
});

export type ExternalDonationRequestsActions =
  | InitAction
  | ApproveAction
  | DenyAction
  | RespondSuccess
  | RespondFailed
  | FetchParamsAction
  | SetTotalAction
  | SetDisplayedDonationIdsAction
  | FetchSuccessAction
  | FetchFailedAction;
